import cn from 'classnames';
import React, { FC, memo, useCallback } from 'react';

import Button, { ButtonProps } from '@components/common/Button';

import { SortDestination } from '@constants/common/common.constants';
import { Variant } from '@constants/common/ui.constants';

import ascIcon from '../../../assets/icons/sortAsc.svg?url';
import descIcon from '../../../assets/icons/sortDesc.svg?url';
import useStyles from './styles.module';

interface Props extends ButtonProps {
  className?: string;
  type: SortDestination;
  onSort: (value: SortDestination) => void;
  isDark?: boolean;
}

const SortButton: FC<Props> = ({
  className = '',
  type,
  onSort,
  isDark = false,
  ...props
}) => {
  const { classes } = useStyles();

  const handleSort = useCallback(() => {
    if (type === SortDestination.Asc) {
      onSort(SortDestination.Desc);
    }
    if (type === SortDestination.Desc) {
      onSort(SortDestination.Asc);
    }
  }, [onSort, type]);

  return (
    <Button
      className={cn(classes.btn, { [classes.btnDark]: isDark }, className)}
      onClick={handleSort}
      variant={Variant.Secondary}
      disableFocusRipple
      {...props}
    >
      {type === SortDestination.Asc ? (
        <img src={ascIcon} alt="" />
      ) : (
        <img src={descIcon} alt="" />
      )}
    </Button>
  );
};

export default memo(SortButton);
